import { Modal } from "MODULES/shared/components";
import { Body, Close, Footer, Header } from "MODULES/shared/components/Modal";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Form as AppForm } from "MODULES/shared/components/Forms";
import { stringify } from "query-string";
import Form from "./Form";

function DownloadPackingSlipModal({
  open,
  close,
  record,
  partKey = "part_number",
  serialKey = "serial_number",
  url
}) {
  const [lineItemIds, setLineItemIds] = useState(
    record.line_items.map(l => l.id)
  );
  const [includeSoldTo, setIncludeSoldTo] = useState(true);

  return (
    <Modal open={open} close={close} dialogClass="modal-md">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Download Packing Slip</h4>
      </Header>
      <Body>
        <Form
          record={record}
          close={close}
          includeSoldTo={includeSoldTo}
          setIncludeSoldTo={setIncludeSoldTo}
          lineItemIds={lineItemIds}
          setLineItemIds={setLineItemIds}
          serialKey={serialKey}
          partKey={partKey}
          url={url}
        />
      </Body>
      <Footer>
        <AppForm.Cancel close={close} editable />
        <AppForm.Submit
          text="Download"
          disabled={false}
          editable
          onClick={() => {
            window.open(
              `${url}&${stringify({
                line_item_ids: lineItemIds.join(","),
                include_sold_to: includeSoldTo
              })}`,
              "_blank"
            );
            close();
          }}
        />
      </Footer>
    </Modal>
  );
}

DownloadPackingSlipModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  partKey: PropTypes.string,
  record: PropTypes.instanceOf(Map),
  serialKey: PropTypes.string,
  url: PropTypes.string
};

export default DownloadPackingSlipModal;



// WEBPACK FOOTER //
// ./app/modules/shared/components/DownloadPackingSlipModal/DownloadPackingSlipModal.jsx